import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import TypeConverter from '@/Utility/TypeConverter';
import KendoTimePickerViewModel from '@/Components/KendoDateTimePicker/ViewModels/KendoTimePickerViewModel';
import KendoTimePicker from '@/Components/KendoDateTimePicker/Controls/KendoTimePicker';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import { FilterInfo } from '#/DefaultViewExtensionInterfaces';
import * as DateHelper from '@/Utility/DateHelper'

export default class KendoTimePickerFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private KendoTimePickerViewModel = ComponentManager.getViewModel<typeof KendoTimePickerViewModel>('KendoTimePickerViewModel');
    private KendoTimePicker = ComponentManager.getControl<typeof KendoTimePicker>('KendoTimePicker');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * @override
     */
    public viewModel: KendoTimePickerViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.KendoTimePickerViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            isFocusable: this.isFocusable,
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            invalidationText: this.invalidationText,
            value: this.context.genericObject.getObservable(this.detailViewItem.name),
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            })
        })

        this.control = new this.KendoTimePicker(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.addOverwritableToControl(this.jQueryControl, [this.detailViewItem.name]);

        this.registerDefaultValidation([this.detailViewItem.name]);
        this.registerCustomValidation([this.detailViewItem.name], this.viewModel.rawValue, (rawValue: any): boolean => {
            let isNullableDateType = TypeConverter.typeIsNullable(this.detailViewItem.dotNetTypeName) || this.detailViewItem.useInFilter;

            if (isNullableDateType) {
                return String.isNullOrEmpty(rawValue) || this.viewModel.date() != null;
            } else {
                return this.viewModel.date() != null;
            }
        });

        return this.jQueryControl;
    }

    public getFilterInfo(): FilterInfo {
        return {
            field: this.detailViewItem.name,
            value: DateHelper.toDotNetDateTimeString(this.viewModel?.date()) || ''
        }
    }
}

ComponentManager.setFactory('KendoTimePicker', KendoTimePickerFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');